// extracted by mini-css-extract-plugin
module.exports = {"banner":"summary_banner__SQNG_"};